import React from "react";
import styles from "./cat.module.scss";
import classnames from "classnames/bind";
import { CatIcon } from "lucide-react";

const classNameBuilder = classnames.bind(styles);

export const Cat = ({ className, hovered, ...rest }) => {
  return (
    <CatIcon
      className={classNameBuilder("container", { hovered }, className)}
      {...rest}
    />
  );
};
